import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { instructionalPinyinText } from './studentInstructionalPinyin';

/** Read-only lesson text: a Typography whose string children show numeric-tone pinyin with tone
 * marks ("da4 bei1" reads "dà bēi"), for text saved before the server converted it and AI text not
 * saved yet. Use this only outside inputs. Non-string children such as elements and numbers pass through. */
export default function LessonText({ children, ...props }: TypographyProps) {
    return <Typography {...props}>{React.Children.map(children, child => typeof child === 'string' ? instructionalPinyinText(child) : child)}</Typography>;
}
